export const ServiceType = {
  FUNERAL: {
    label: "Funeral Service",
    path: "/bookings/add/funeral",
    fields: [],
  },
  FUNERAL_HOME: {
    label: "Funeral Home ",
    path: "/bookings/add/funeral-home",
    fields: [],
  },
  CHURCH: {
    label: "Church Service",
    path: "/bookings/add/church",
    fields: [],
  },
  CONFERENCE: {
    label: "Conference",
    path: "/bookings/add/conference",
    fields: [],
  },
  EVENT: {
    label: "Event",
    path: "/bookings/add/event",
    fields: [],
  },
  OTHER: { label: "Other Service", path: "/bookings/add/other", fields: [] },
};

export type ServiceTypeKey = keyof typeof ServiceType;

export interface ServiceTypeConfig {
  fields: unknown[];
}

export interface ServiceTypes {
  [key: string]: ServiceTypeConfig;
}
